import { formatNumber } from "accounting"
import { Flex, Skeleton, Tag, Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import EmptyComponent from "../../../../Components/Empty"
import Private from "../../../../Components/Private"
import Icon from "../../../../Icon"
import { formatCurrency } from "../../../../Utils/utils"
import { CHANNEL_META } from "../../../ReceiptPage/constants/receipt-status-mapping"
import { programIcon, programLabel } from "../../utils/vocabulary"
import { RankMark, rateText } from "../repeatColumns"

import styles from "./repeatCardholdersList.module.less"

const { Text } = Typography

const RepeatCardholderCard = ({ record }) => {
  const { t } = useTranslation()
  const channel = CHANNEL_META[record.top_channel]

  return (
    <Flex vertical gap={8} className={styles.card}>
      <Flex justify="space-between" align="center">
        <Flex gap={8} align="center">
          <RankMark rank={record.sequence_number} />
          <Text strong style={{ fontVariantNumeric: "tabular-nums" }}>
            <Private>{`•••• ${record.card_last4}`}</Private>
          </Text>
        </Flex>
        <Flex gap={4} align="center">
          <Icon type={programIcon(record.program)} style={{ fontSize: 20, lineHeight: 1 }} />
          <Text strong>{t(programLabel(record.program))}</Text>
        </Flex>
      </Flex>
      <Flex justify="space-between" align="center">
        {channel ? (
          <Tag color={channel.color} style={{ margin: 0 }}>
            {t(channel.label)}
          </Tag>
        ) : (
          <Text>{t(record.top_channel_label)}</Text>
        )}
        <Text strong>
          <Private>{formatCurrency(record.order_amount, true)}</Private>
        </Text>
      </Flex>
      <Flex justify="space-between" align="center">
        <Text type="secondary" style={{ fontSize: 12 }}>
          {record.last_lookup_at ? dayjs(record.last_lookup_at).format("DD MMM YYYY") : "-"}
        </Text>
        <Text type="secondary" style={{ fontSize: 12 }}>
          <Private>
            {`${formatNumber(record.lookups_count)} ${t("lookups")} · ${rateText(
              record.match_rate,
              record.matched_count,
              record.lookups_count
            )}`}
          </Private>
        </Text>
      </Flex>
    </Flex>
  )
}

const RepeatCardholderCardSkeleton = () => (
  <Flex vertical gap={8} className={styles.card}>
    {[
      [96, 88],
      [88, 64],
      [80, 120]
    ].map(([left, right], i) => (
      <Flex key={i} justify="space-between" align="center">
        <Skeleton.Button active size="small" style={{ width: left, height: 16 }} />
        <Skeleton.Button active size="small" style={{ width: right, height: 16 }} />
      </Flex>
    ))}
  </Flex>
)

// The mobile face of the repeat-cardholder table: one card per row, same data and ranking.
export const RepeatCardholdersList = ({ loading, data, skeletonCount }) => {
  if (loading) {
    return (
      <div className={styles.grid}>
        {Array.from({ length: skeletonCount }).map((_, i) => (
          <RepeatCardholderCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (!data?.length) return <EmptyComponent type="no_data_available" />

  return (
    <div className={styles.grid}>
      {data.map((record) => (
        <RepeatCardholderCard key={record.sequence_number} record={record} />
      ))}
    </div>
  )
}
